/**
 * Formulierinzendingen doorgeven aan de datalaag.
 *
 * Contact Form 7 verstuurt met fetch en roept preventDefault aan, waardoor de
 * ingebouwde formuliertrigger van Google Tag Manager nooit afgaat. Gemeten met
 * een echte inzending: de datalaag kreeg alleen gtm.js, gtm.dom en gtm.load.
 * Er werd dus geen enkele sollicitatie of contactaanvraag geteld.
 *
 * Contact Form 7 vuurt sinds versie 6 nog maar drie events af. De oude namen
 * wpcf7mailsent, wpcf7invalid en wpcf7mailfailed bestaan niet meer. Alles loopt
 * nu via wpcf7submit, met de uitkomst in detail.status.
 */

const uitkomsten = {
  mail_sent: 'formulier_verzonden',
  validation_failed: 'formulier_ongeldig',
  acceptance_missing: 'formulier_ongeldig',
  mail_failed: 'formulier_mislukt',
  spam: 'formulier_geweigerd',
  aborted: 'formulier_afgebroken',
};

/**
 * Een leesbare naam voor het formulier, zodat je in Tag Manager onderscheid
 * kunt maken tussen een sollicitatie en een contactaanvraag.
 *
 * Eerst de plek op de pagina, want Contact Form 7 hangt aan elk formulier
 * hetzelfde algemene label "Contactformulier".
 */
function formuliernaam(detail) {
  if (document.querySelector('.vacancy-apply .wpcf7-form')) return 'sollicitatie vacature';
  if (document.body.classList.contains('page-template-template-open-application')) return 'open sollicitatie';

  const eenheid = detail && detail.unitTag ? String(detail.unitTag) : '';
  const wrapper = eenheid && document.getElementById(eenheid);
  const formulier = wrapper ? wrapper.querySelector('form') : null;
  const label = formulier ? formulier.getAttribute('aria-label') : '';

  return label || 'overig';
}

document.addEventListener('wpcf7submit', (e) => {
  const detail = e.detail || {};
  const naam = uitkomsten[detail.status];

  // Een onbekende uitkomst laten we liggen, anders tellen we iets wat we niet
  // kunnen duiden.
  if (!naam) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: naam,
    formulier_id: detail.contactFormId ? String(detail.contactFormId) : '',
    formulier_naam: formuliernaam(detail),
    // De vacature waar de sollicitatie over gaat, als die er is.
    vacature: (document.querySelector('#vacancy-context') || {}).value || '',
  });
}, false);
